<template>
  <div>
    <div class="flex flex-wrap mb-3">
      <div class="w-full flex flex-wrap justify-center">
        <div class="flex items-center w-3/5 sm:w-2/5 lg:w-1/5 ">
          <label class="w-1/4 block font-bold text-tiny">Year :</label>
          <div class="relative w-1/2 border-none max-h-9">
            <select v-model="selectedYear" @change="getData()" class="text-black-400 border border-black-500  inline-block py-2 pl-3 pr-8 rounded leading-tight w-full">
              <option v-for="year in years" :value="year">
                {{ year }}
              </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
              <i class="fas fa-chevron-down text-gray-400"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        Digital edition
      </h1>
    </div>


<!--    <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">Digital edition</h1>-->
<!--    <hr />-->
    <div
      class="
        grid grid-cols-2
        sm:grid-cols-3
        md:grid-cols-4
        lg:grid-cols-6
        content-center
        pt-11
      "
      v-if="ready"
    >
      <div
        class="flex flex-col items-center mb-3.5 md:mb-7"
        v-for="(issue,index) in issues"
        :key="issue.id"
      >
        <form
            :ref="el => tokenForms[issue.id] = el"
            method="post" :action="config.siteURL+'/api/assets/all-issues/'+issue.name+'/'">
          <input type="hidden" name="idToken" :value="idToken">
        </form>
<!--        <NuxtLink-->
<!--            :href="config.siteURL+'/api/assets/all-issues/'+issue.name+'/'+'?idToken='+idToken"-->
<!--                  class="hover:opacity-70">-->
<!--          <img :src="usePhoto('/storage'+issue.cover)" alt="" width="110" height="132" />-->
<!--        </NuxtLink>-->
        <template v-if="index<1">
          <img
              width="110"
              height="132"
              :src="issue.link" class="cursor-pointer"
              :alt="issue.name"
              @click="tokenForms[issue.id].submit()" />
        </template>
        <template v-else>
          <img
              width="110"
              height="132"
              loading="lazy"
              :src="issue.link" class="cursor-pointer hover:opacity-75"
              :alt="issue.name"
              @click="tokenForms[issue.id].submit()" />
        </template>
        <NuxtLink
            @click="tokenForms[issue.id].submit()"
          class="
          cursor-pointer
            inline-block
            text-veryDarkGray
            hover:text-grayLight
            underline underline-offset-1
            font-semibold
            pt-2.5
            pb-7
            text-tiny
          "
          >{{issue.definition_issue? issue.definition_issue.title : issue.name }}</NuxtLink
        >
      </div>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>
<script setup>
import { http } from "~/utils/http";
import {onMounted, ref,onUpdated} from "vue";
import {useRuntimeConfig} from "nuxt/app";
import Input from "../../components/Input";

const config = useRuntimeConfig();
const idToken = useCookie("idToken");
const tokenForms = ref([]);
const issues = ref([]);
const ready = ref(false);
let page = ref(1);
let selectedYear = ref('0');
const years = ref([]);
const getData = async () => {
  try {
    await http
      .get("/api/issues/", {
        params: {
          year: selectedYear.value,
        },
      })
      .then((response) => {
        console.log('asdasda',response.data)
        issues.value = response.data.issues;
        years.value = response.data.years;
        selectedYear.value =  response.data.currentYear;
        ready.value = true;
      });
  } catch (e) {}
};
getData();
// onMounted(() => {
//   window.onscroll = () => {
//     let bottomOfWindow =
//       document.documentElement.scrollTop + window.innerHeight ===
//       document.documentElement.offsetHeight;
//     if (bottomOfWindow) {
//       page.value++;
//       getIssues(page.value);
//     }
//   };
// });
// onUpdated(() => {
//   let smallContent =
//     window.innerHeight > document.documentElement.offsetHeight - 200;
//   if (smallContent) {
//     page.value++;
//     getIssues(page.value);
//   }
// });
</script>
